import { Link } from "@reach/router";
import React, { Component } from "react";
import { connect } from "react-redux";
import config from "../../../utils/config";

class Sidebar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isTooltipVisible: false,
    };
    this.mounted = true;
  }
  handleMouseEnter = () => {
    this.setState({ isTooltipVisible: true });
  };

  handleMouseLeave = () => {
    this.setState({ isTooltipVisible: false });
  };
  componentDidMount() {
    this.mounted = true;
  }
  componentWillUnmount() {
    this.mounted = false;
  }

  render() {
    const { content } = this.props;
    const { isTooltipVisible } = this.state;
    return (
      <div className="sidebar_cont sidebar-responsive" id="sidebar">
        <div className="sidebarinner_cont">
          <ul className="sidebar_menu">
            {this.props.userMenuData.map((item, index) => (
              <li key={index} className={item.menuName}>
                <Link to={item.route}>
                  <i className={`${item.iconClass}`}></i>
                  {/* <span>{item.menuName}</span> */}
                </Link>
              </li>
            ))}
          </ul>
          <div
            className="footersitelogo"
            onMouseEnter={this.handleMouseEnter}
            onMouseLeave={this.handleMouseLeave}
          >
            <a
              id="tooltip-target"
              href={
                this.props.userData.roleId == 2
                  ? "/NGODashboardNew"
                  : "/NGODashboardNew"
              }
            >
              <img
                src={`${config.Amazon_WebService_CDNUrl}/websites/staticimages/bottomLogoIcon.png`}
                alt="growdashlogo"
              />
            </a>
            {isTooltipVisible && (
              <div className="footerlogo_toltip">Powered By TreeTies</div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    token: state.configuration.token,
    userData: state.user.userData,
    userMenuData: state.user.userMenuData,
  };
}

export default connect(mapStateToProps)(Sidebar);
